import { render, staticRenderFns } from "./DeleteMyAccountDialog.vue?vue&type=template&id=0ddc1065&"
import script from "./DeleteMyAccountDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteMyAccountDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports